import { useSyncExternalStore, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { cn } from '@/lib/utils'

export const WEBVIEW_HEADER_ACTIONS_ID = 'webview-header-actions'

const listeners = new Set<() => void>()
let headerActionsHost: HTMLElement | null = null

function subscribeHeaderActionsHost(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function getHeaderActionsHost() {
  return headerActionsHost
}

function setHeaderActionsHost(node: HTMLElement | null) {
  if (headerActionsHost === node) return
  headerActionsHost = node
  listeners.forEach((listener) => listener())
}

export function WebviewHeaderActionsSlot({ className }: { className?: string }) {
  return (
    <div
      id={WEBVIEW_HEADER_ACTIONS_ID}
      ref={setHeaderActionsHost}
      className={cn('relative', className)}
    />
  )
}

export function WebviewHeaderActions({ children }: { children: ReactNode }) {
  const host = useSyncExternalStore(subscribeHeaderActionsHost, getHeaderActionsHost, () => null)
  if (!host) return null
  return createPortal(children, host)
}
